import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef57bad6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "course-track" }
const _hoisted_2 = { class: "course-track__content" }
const _hoisted_3 = { class: "course-track__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_course = _resolveComponent("course")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(_toDisplayString(_ctx.courseTrack) + " ", 1),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.courseTrack.id) + " " + _toDisplayString(_ctx.courseTrack.title), 1),
        (_ctx.courses.length)
          ? (_openBlock(), _createBlock(_component_carousel, {
              key: 0,
              settings: _ctx.settings,
              breakpoints: _ctx.breakpoints
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    key: 'course' + index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_course, { course: course }, null, 8, ["course"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["settings", "breakpoints"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}